import React from "react"
import PropTypes from "prop-types"
import { HorizontalPlan } from "./horizontal-plan"
import "./plan.scss"

// A Helper component so we can swap between horizontal or vertical plans
// This should be based on data, though doing so really means we would also need to
// affect plan-list's styling to match
const Plan = props => {
  return <HorizontalPlan {...props} />
}

Plan.propTypes = {
  data: PropTypes.shape({
    minutes: PropTypes.string,
    texts: PropTypes.string,
    data: PropTypes.string,
    contractLength: PropTypes.string,
    network: PropTypes.string,
    speed: PropTypes.string,
    speedBolts: PropTypes.number,
    speedList: PropTypes.object,
    speedIcons: PropTypes.arrayOf(PropTypes.string)
  }),
  costs: PropTypes.shape({
    airtime: PropTypes.number,
    handset: PropTypes.number,
    maf: PropTypes.number,
    upfront: PropTypes.number
  }),
  style: PropTypes.string.isRequired,
  benefits: PropTypes.object,
  excludeVAT: PropTypes.bool,
  getPlanOptionWithName: PropTypes.func
}

Plan.defaultProps = {
  benefits: undefined,
  excludeVAT: false
}

export default Plan
